module.exports = __webpack_public_path__ + "static/media/Kit Welcome - Light.678d1576.svg";